import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { WebLayout } from "../components/web-layout";
import { useProfile, useUserEnrollMutation } from "./queries";
import { LoadingContainer } from "../components/loading-container";
import { useQueryString } from "../../hooks/use-query-string";

const alignCenter: { [key: string]: string } = {
    textAlign: "center",
};

export default function DisenrollUser() {
    const enrollUser = useUserEnrollMutation();
    const { token } = useParams<{ token: string }>();
    const [loading, setLoading] = useState<boolean>(false);
    const [result, setResult] = useState<string>("");
    const query = useQueryString();

    const { isLoading, isSuccess, data: profile } = useProfile(token!);

    const onEnrollBtnClick = async () => {
        let status: string;
        try {
            setLoading(true);
            await enrollUser.mutateAsync({ token: token! });
            status = "enrolled";
        } catch {
            status = "error";
        }

        setResult(status);
        // update the status on url. This is required for mobile app to redirect back to mobile.
        setTimeout(() => {
            window.location.href = `${window.location.href}?status=${status}`;
        }, 2000);
    };

    useEffect(() => {
        if (query.get("status") === undefined || query.get("status") === null) {
            let status = "";
            if (isSuccess && profile?.has_error) {
                status = "error";
            } else if (isSuccess && profile?.enrolled) {
                status = "success";
            }

            // update the status on url. This is required for mobile app to redirect back to mobile.
            if (status) {
                setTimeout(() => {
                    window.location.href = `${window.location.href}?status=${status}`;
                }, 2000);
            }
        }

        if (query.get("status") === "enrolled") {
            setResult("enrolled");
        }
    }, [profile, query, isSuccess]);

    // Render after submitting the enroll request.
    if (result) {
        return (
            <WebLayout showFooter={false}>
                {result === "enrolled" ? (
                    <div>
                        <p style={alignCenter}>Congratulation!!</p>
                        <p style={alignCenter}>
                            You have successfully enrolled. Click{" "}
                            <Link to="/">here</Link> to login.
                        </p>
                    </div>
                ) : (
                    <p style={alignCenter}>
                        Oops!! Enrollment failed. Please contact admin.
                    </p>
                )}
            </WebLayout>
        );
    }

    // Invalid url handling
    if (isSuccess && profile && profile.has_error) {
        return (
            <WebLayout showFooter={false}>
                <p style={alignCenter}>Invalid URL. Please contact admin.</p>
            </WebLayout>
        );
    }

    // option for user to enroll
    return (
        <WebLayout showFooter={false}>
            {isLoading && <LoadingContainer />}

            {isSuccess && profile && profile.enrolled ? (
                <div style={alignCenter}>
                    You have already enrolled!! Click <Link to="/">here</Link>{" "}
                    to login.
                </div>
            ) : (
                <div style={alignCenter}>
                    {isSuccess && profile && (
                        <>
                            <h4>
                                Hi {profile.first_name} {profile.last_name}
                            </h4>
                            <p>
                                Welcome back, please click the below button to
                                enroll.
                            </p>
                            <Button
                                className="btn btn-success"
                                onClick={onEnrollBtnClick}
                                disabled={loading}
                            >
                                Enroll
                            </Button>
                        </>
                    )}
                </div>
            )}
        </WebLayout>
    );
}
